module.exports = __webpack_public_path__ + "static/media/logo-grejo.0fbf243b.png";